// extracted by mini-css-extract-plugin
module.exports = {"container":"_1gQhGeV9UDcboI2faj4IeR"};